import { render, staticRenderFns } from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=template&id=2d5a22f8&scoped=true"
import script from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=script&lang=js"
export * from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=style&index=0&id=2d5a22f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a22f8",
  null
  
)

export default component.exports